<template>
  <div>
  <section>
        <div class="container">
            <ol class="breadcrumb hidden-xs">
                <li><a href="/">首頁</a></li>
                <li class="active">聯絡我們</li>
            </ol>
            <div class="row">
                <div class="col-sm-6 col-xs-12">
                    <h4 class="title">聯絡資訊</h4>
                    <div class="contact_box">
                        <h5>愛幫您股份有限公司</h5>
                        <ul class="list-unstyled contact_info">
                            <li>服務時間：週一至週五, 09:00 - 18:00</li>
                            <li>服務電話：03-4593159 0909-413-131</li>
                            <li>服務地址：桃園市中壢區吉長街14號</li>
                        </ul>
                    </div>
                    <iframe width='100%' height='250' frameborder='0' scrolling='no' marginheight='0' marginwidth='0'
                        src='https://maps.google.com.tw/maps?f=q&hl=zh-TW&geocode=&q=桃園市中壢區吉長街14號&z=16&output=embed&t='>
                    </iframe>
                </div>
                <div class="col-sm-6 col-xs-12">
                    <h4 class="title">聯絡我們</h4>
                    <p class="editor">您有任何需求要與本網站聯繫，請於下方表單填寫即可。我們有專人會儘速為您提供服務。</p>
                    <div class="">
                        <form class="form-horizontal">
                            <div class="form-group">
                                <label for="name" class="col-sm-2 control-label">姓名</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" v-model="name" placeholder="姓名">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="email" class="col-sm-2 control-label">Email</label>
                                <div class="col-sm-9">
                                <input type="email" class="form-control" v-model="email" placeholder="Email">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="phone" class="col-sm-2 control-label">電話</label>
                                <div class="col-sm-9">
                                    <input type="text" class="form-control" v-model="phone" placeholder="電話">
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="message" class="col-sm-2 control-label">訊息</label>
                                <div class="col-sm-9">
                                    <textarea class="form-control" v-model="content"  placeholder="訊息" rows="5"></textarea>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-sm-offset-2 col-sm-9">
                                    <button type="button" @click="contact()" class="btn btn-default i80_btn">留言</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  metaInfo: {
    title: '愛幫您-聯絡我們',
    meta: [{
      name: '愛幫您-聯絡我們',
      content: '歡迎與我們聯絡合作方案'
    }],
    link: [{
      rel: 'contact',
      href: 'https://www.i80.com.tw/contact'
    }]
  },
  data () {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      name: '',
      phone: '',
      email: '',
      content: ''
    }
  },
  mounted: function () {
    this.$http.get(this.apiurl + '/latestAffiliate').then(function (res) {
      this.latest = res.body.data
    }, function () {
      console.log('failed')
    })
  },
  methods: {
    contact () {
      let str = ''
      if (this.name === '') {
        str += '請填寫姓名。\n'
      } else if (this.email === '' || typeof this.email === 'undefined') {
        str += '請輸入您的Email\n'
      } else if (this.content === '' || typeof this.content === 'undefined') {
        str += '請輸入您的問題。\n'
      } else if (this.phone === '' || typeof this.phone === 'undefined') {
        str += '請輸入您的聯絡電話\n'
      }
      if (str === '') {
        this.$http.post(this.apiurl + 'api/messages', {
          email: this.email,
          name: this.name,
          phone: this.phone,
          content: this.content
        }).then(function (res) {
          let status = res.status
          if (status === 200) {
            window.alert('留言成功，我們將盡快回覆您。')
          } else {
            window.alert('留言失敗')
          }
        }, function () {
          console.log('failed')
        })
      } else {
        window.alert(str)
      }
    }
  },
  computed: {
  }
}
</script>



// WEBPACK FOOTER //
// Contact.vue?4258e2f9